<template>
    <div class="content-raw-data-wrapper" :class="{ 'raw-data-left': embedded }">
        <template v-if="embedded">
            <v-text-field v-model="searchQuery" class="content-data-search raw-data-search" flat label="Suche"
                prepend-inner-icon="mdi-magnify" variant="outlined" density="compact" hide-details single-line
                rounded="lg"></v-text-field>
            <div v-for="(value, key) in filteredAgency" :key="key" class="dialog-raw-data-content">
                <h4>{{ key }}</h4>
                <p>{{ value || "--" }}</p>
            </div>
        </template>
        <v-expansion-panels v-else flat v-model="showRawData">
            <v-expansion-panel>
                <v-expansion-panel-title>
                    <h3>Raw Data</h3>
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                    <v-text-field v-model="searchQuery" class="content-data-search raw-data-search" flat label="Suche"
                        prepend-inner-icon="mdi-magnify" variant="outlined" density="compact" hide-details single-line
                        rounded="lg"></v-text-field>
                    <div v-for="(value, key) in filteredAgency" :key="key" class="dialog-raw-data-content">
                        <h4>{{ key }}</h4>
                        <p>{{ value || "--" }}</p>
                    </div>
                </v-expansion-panel-text>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
export default {
    props: {
        agency: {
            type: Object,
            required: true
        },
        embedded: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showRawData: false,
            searchQuery: ''
        };
    },
    computed: {
        handleRawDataIcon() {
            return this.showRawData ? 'mdi-chevron-up' : 'mdi-chevron-down';
        },
        filteredAgency() {
            if (!this.searchQuery) return this.agency;
            const searchLower = this.searchQuery.toLowerCase();
            return Object.entries(this.agency).reduce((acc, [key, value]) => {
                // Check if either the key or the string representation of the value includes the search query
                if (key.toLowerCase().includes(searchLower) || String(value).toLowerCase().includes(searchLower)) {
                    acc[key] = value;
                }
                return acc;
            }, {});
        }
    },
    methods: {
        handleShowRawData() {
            this.showRawData = !this.showRawData;
        }
    }
};
</script>

<style lang="scss" scoped>
.content-raw-data-wrapper.raw-data-left {
  align-items: flex-start;
  width: 100%;
}

.raw-data-search {
  width: 100%;
  max-width: 100%;
}
</style>